/** Oznake, ki jih novica sme uporabiti (osnovni HTML: krepko, poševno, prelomi, seznami). */
const DOVOLJENE = new Set([
  'B',
  'STRONG',
  'I',
  'EM',
  'U',
  'BR',
  'P',
  'UL',
  'OL',
  'LI',
  'SPAN',
  'DIV',
  'H1',
  'H2',
  'H3',
]);

/**
 * HTML novice za prikaz: ohrani samo dovoljene oznake brez atributov, ostalo pretvori v besedilo. Novice vpisujemo
 * sami, a v brskalniku vseeno ne izvajamo ničesar iz baze (skripte, povezave, slike, dogodki).
 */
export function varnHtml(html: string): string {
  const dokument = new DOMParser().parseFromString(`<div>${html}</div>`, 'text/html');
  const ocisti = (vozel: Node): string => {
    if (vozel.nodeType === Node.TEXT_NODE) {
      const div = document.createElement('div');
      div.textContent = vozel.textContent ?? '';
      return div.innerHTML;
    }
    if (vozel.nodeType !== Node.ELEMENT_NODE) {
      return '';
    }
    const el = vozel as Element;
    const notranje = [...el.childNodes].map(ocisti).join('');
    if (!DOVOLJENE.has(el.tagName)) {
      return el.tagName === 'SCRIPT' || el.tagName === 'STYLE' ? '' : notranje;
    }
    const oznaka = el.tagName.toLowerCase();
    return oznaka === 'br' ? '<br>' : `<${oznaka}>${notranje}</${oznaka}>`;
  };
  return [...dokument.body.firstChild!.childNodes].map(ocisti).join('');
}
